export const mobileNavBarRoutes = [
  "/account/tools",
  "/incomes",
  "/myms",
  "/app/profile",
  "/notifications",
  "/my-account"
];
